<template lang="pug">
.page.container
  .row
    .col-12
      img(src='../../assets/logo-green@3x.png')
  .row
    form.col-12.col-md-6.offset-md-3
      .card
        .logo
          img(src='../../assets/habitica.svg')
          .title Log in with Habitica
        div(v-if='loginMethod === "button"')
          .form-group
            .btn-green(@click='loginToHabitica()', :disabled='loading') Login
          .form-group.text-center
            .link(@click='loginMethod = "keys"') Login with Keys
        div(v-else)
          .form-group
            label User ID
            input.form-control(type='email', v-model='apiUserId')
          .form-group
            label API Token
            input.form-control(type='password', v-model='apiKey')
          .form-group
            .btn-green(@click='login()', :disabled='loading') Login
          .form-group.text-center
            .link(@click='loginMethod = "button"') Login with Habitica
</template>

<style lang="scss" scoped>
  .page {
    margin-top: 2em;
  }

  img {
    max-width: 235.6px;
    margin: 2rem auto;
  }

  .logo {
    width: 100%;
    text-align: center;

    img {
      margin: 0 auto;
      display: block;
      margin-bottom: 1rem;
    }

    .title {
      margin-bottom: 1rem;
      font-size: 20px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.4;
      letter-spacing: normal;
      text-align: center;
      color: #363734;
    }
  }

  .card {
    text-align: left;
    max-width: 384px;
    margin: 0 auto;
    padding: 2rem;
    border: none;
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: 0 2px 2px 0 rgba(31, 31, 31, 0.12), 0 0 2px 0 rgba(31, 31, 31, 0.12);
  }

  label {
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: #6c6d69;
  }

  .btn-green {
    margin: 0 auto;
    margin-top: 1rem;
    border-radius: 999px;
    background-image: linear-gradient(to right, #9bc75a, #3ba5a8);
    text-align: center;
    max-width: 150px;
    display: block;
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: 1px;
    text-align: center;
    color: #f7f8f6;
    text-transform: uppercase;
  }

  .link {
    color: #3ba5a8;
  }

  .link:hover {
    cursor: pointer;
  }
</style>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      apiKey: '',
      apiUserId: '',
      loading: false,
      loginMethod: 'button',
    };
  },
  methods: {
    async login() {
      if (this.loading) return;
      this.loading = true;

      const response = await axios
        .post('/auth/habitica', {
          apiKey: this.apiKey,
          apiUserId: this.apiUserId,
        })
        .catch((e) => {
          alert(e.response.data.message);
        });

      if (!response) {
        this.loading = false;
        return;
      }

      // @TODO: move to store
      const userTokenData = response.data.data;
      localStorage.setItem('habitica-token-user', JSON.stringify(userTokenData));

      axios.defaults.headers.common.Authorization = `Bearer ${userTokenData.token}`;

      this.$root.$emit('sprite:loadUserDetails');

      this.$router.push('/');
    },
    loginToHabitica() {
      window.amplitude.getInstance().logEvent('HABITICA_LOGIN');
      const url = 'https://habitica.com/user/settings/api';
      this.openSocialLoginWindow(url);
    },
    openSocialLoginWindow(socialUrl) {
      // From http://www.gethugames.in/2012/04/authentication-and-authorization-for-google-apis-in-javascript-popup-window-tutorial.html
      const win = window.open(socialUrl, 'oauth-window', 'width=500, height=500');
      const pollTimer = window.setInterval(() => {
        win.postMessage('api-request', '*');
        function recieveMessage(event) {
          if (event.origin !== 'https://habitica.com') return;

          this.apiKey = event.data.apiToken;
          this.apiUserId = event.data.userId;
          this.login();

          window.clearInterval(pollTimer);
          win.close();
          window.removeEventListener('message', recieveMessage);
        }
        window.addEventListener('message', recieveMessage.bind(this), false);
      }, 1000);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/auth/HabiticaLogin.vue